import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch } from "react-redux";
import getProducts from '../../redux/actions/products/getProducts';
import appLS from '../../constants/local-storage';
// import getUser from '../../redux/actions/user/getUser';

/**
 * function redirects to the home route after dispatching products, 
 * So on first sign in user will be getting the products. 
 */
function Redirect({ history }) {

  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(getUser());
    dispatch(getProducts());
    const url = localStorage.getItem(appLS.redirectUrl)
    if (url) {
      history.push(url);
    } else {
      history.push('/');
    }
  }, [history, dispatch]);

  return (<></>);
}

export default withRouter(Redirect);